import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './ui.css';

/**
 * Content card. When `to` is supplied the whole card becomes a single link —
 * one tab stop, with the title carrying the accessible name, rather than a
 * card containing a separate "Learn more" link that duplicates it.
 */
const Card = ({
  icon,
  title,
  body,
  to,
  tone,
  headingLevel = 3,
  footer,
  children,
  className = '',
}) => {
  const Heading = `h${headingLevel}`;
  const classes = [
    'card',
    to ? 'card--link' : '',
    tone === 'navy' ? 'card--navy' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const inner = (
    <>
      {icon && (
        <span className="card__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      {title && <Heading className="card__title">{title}</Heading>}
      {body && <p className="card__body">{body}</p>}
      {children}
      {to && (
        <span className="card__footer link-arrow" aria-hidden="true">
          Learn more <FiArrowRight />
        </span>
      )}
      {footer && !to && <div className="card__footer">{footer}</div>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes}>
        {inner}
      </Link>
    );
  }

  return <div className={classes}>{inner}</div>;
};

export default Card;
